import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/responsive.css";
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import persistStore from "redux-persist/es/persistStore";
import Store from "./redux/Store";
import PageNavigations from "./pageNavigations"

let persistor = persistStore(Store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <PersistGate persistor={persistor}>      
        <PageNavigations />      
    </PersistGate>
  </Provider>  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
